import { render, staticRenderFns } from "./SmsBuilder.vue?vue&type=template&id=096244c8&lang=pug&"
import script from "./SmsBuilder.vue?vue&type=script&lang=js&"
export * from "./SmsBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SmsBuilder.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports